
import React from 'react';
import { cn } from '@/lib/utils';

interface DisplaySlideProps {
  children: React.ReactNode;
  className?: string;
  background?: 'default' | 'gradient' | 'subtle' | 'enhanced';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  direction?: 'rtl' | 'ltr';
}

export const DisplaySlide: React.FC<DisplaySlideProps> = ({
  children,
  className,
  background = 'enhanced',
  padding = 'lg',
  direction = 'rtl'
}) => {
  const backgroundClasses = {
    default: 'bg-white/20 backdrop-blur-md',
    gradient: 'bg-gradient-to-br from-white/30 to-white/10 backdrop-blur-md',
    subtle: 'bg-white/10 backdrop-blur-sm',
    enhanced: 'bg-gradient-to-br from-white/25 via-white/15 to-white/10 backdrop-blur-xl border border-white/20'
  };

  const paddingClasses = {
    sm: 'p-3 sm:p-4',
    md: 'p-4 sm:p-6 md:p-8',
    lg: 'p-6 sm:p-8 md:p-10 lg:p-12',
    xl: 'p-8 sm:p-10 md:p-12 lg:p-16 xl:p-20'
  };

  return (
    <div 
      className={cn(
        "w-full h-full rounded-2xl shadow-2xl overflow-hidden",
        "transition-all duration-500 ease-in-out",
        "hover:shadow-3xl hover:scale-[1.01]",
        backgroundClasses[background],
        paddingClasses[padding],
        direction === 'rtl' ? 'text-right' : 'text-left',
        className
      )}
      dir={direction}
    >
      <div className="w-full h-full flex flex-col">
        {children}
      </div>
    </div>
  );
};
